import React, { useState, useEffect } from "react";
import LandingPage from "./Home-page/Landing-page";
import About from "./Home-page/About";
import Blog from "./Home-page/Blog";
import Infographic from "./Home-page/Infographic";
import Main from "./Home-page/main";
import Contact from "./Home-page/Contact";

function HomePage() {
  

  return (
    <>
    <Main />
      <About />
      <Infographic />

      <Contact />
      {/* <LandingPage /> */}
      {/* <Blog /> */}
    </>
  );
}

export default HomePage;


    
